import moment from "moment";
import constant from "../../../../../constants/constant";
import atoms from "../../../../atoms";
import { InventoryDetailProps } from "../interface";
import { getRegionTaxCode } from "../../../../../constants/utils";

const { Select, Input, FileInput } = atoms;

export const InventoryDetail: React.FC<InventoryDetailProps> = ({
    invoiceData,
    errors,
    handleChange,
    fileRef,
    handleFileChange,
}) => {
    const store_gst_type = Number(localStorage.getItem("store_gst_type"));

    // Utility: pick appropriate label and placeholder for supplier invoice number
    const invoiceLabelMap: Record<string, string> = {
        SAMPLE: "Delivery Challan",
        WARRANTY: "Claim ID",
        "FREE GOODS": "Ref. Supplier Invoice Number",
    };

    const invoicePlaceholderMap: Record<string, string> = {
        SAMPLE: "Enter Delivery Challan",
        WARRANTY: "Enter Claim ID",
        "FREE GOODS": "Enter Supplier Invoice Number",
    };

    const categoryLabel: string = invoiceData?.category?.label || "";
    const supplierInvoiceLabel =
        invoiceLabelMap[categoryLabel] || "Supplier Invoice Number";
    const supplierInvoicePlaceholder =
        invoicePlaceholderMap[categoryLabel] || "Enter Invoice Number";

    // GST invoice conditional logic
    const isRegularGST =
        store_gst_type === constant.GST_DETAILS.REGULAR &&
        invoiceData?.category?.value === constant.STORE_INVOICE_CATEGORY[1].value;

    return (
        <div className="row">
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mt-3">
                <Select
                    label="Category"
                    className="w-100"
                    placeholder="Select Category"
                    options={constant.STORE_INVOICE_CATEGORY}
                    value={invoiceData?.category}
                    errors={errors.category}
                    onChange={(e: any) => handleChange("category", e)}
                />
            </div>

            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mt-3">
                <Input
                    label="Supplier"
                    type="text"
                    placeholder="Select Supplier"
                    className="w-100 zIndex-3"
                    value={invoiceData?.local_supplier_name}
                    errors={errors.local_supplier_name}
                    onChange={(e: any) =>
                        handleChange("local_supplier_name", e.target.value)
                    }
                />
            </div>

            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mt-3">
                <Input
                    label={supplierInvoiceLabel}
                    type="text"
                    placeholder={supplierInvoicePlaceholder}
                    value={invoiceData?.supplier_invoice_number}
                    errors={errors.supplier_invoice_number}
                    onChange={(e: any) =>
                        handleChange("supplier_invoice_number", e.target.value)
                    }
                />
            </div>

            {isRegularGST && (
                <div className="col-12 col-sm-6 col-md-4 col-lg-3 mt-3">
                    <Select
                        label={`${getRegionTaxCode()} Invoice`}
                        className="w-100 zIndex-3"
                        placeholder={`Select ${getRegionTaxCode()} Invoice`}
                        options={constant.GST_Invoice}
                        value={invoiceData?.gst_invoice}
                        errors={errors.gst_invoice}
                        onChange={(e: any) => handleChange("gst_invoice", e)}
                    />
                </div>
            )}

            <div className="col-12 col-sm-6 col-md-4 col-lg-3 mt-3">
                <Input
                    label="Invoice Date"
                    placeholder="Enter Invoice Date"
                    type="date"
                    value={moment(invoiceData?.supplier_invoice_date).format("YYYY-MM-DD")}
                    errors={errors.supplier_invoice_date}
                    onChange={(e: any) =>
                        handleChange("supplier_invoice_date", e.target.value)
                    }
                />
            </div>

            <div className="col-12 col-md-6 d-flex mt-3">
                <FileInput
                    label="Invoice File"
                    type="file"
                    fileRef={fileRef}
                    accept="image/png, image/jpg, image/jpeg, image/webp, application/pdf"
                    // errors={errors.invoice_file}
                    onChange={handleFileChange}
                    multiple
                />
            </div>
        </div>
    );
};
